<template>
  <el-autocomplete
    v-model="tempValue"
    @select="selectSchool"
    :fetch-suggestions="querySearchAsync"
    :placeholder="placeholder"
    :blur="clearInput"
    ref="complete"
    :clearable="clearable"
    @clear="clearInput"
    v-bind="$attrs"
  >
  </el-autocomplete>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'GkrySchoolSearch',
  props: {
    value: [Object, String, Number],
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请输入学校',
    }
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      tempValue: null,
    };
  },
  computed: {
    showDeleteIcon() {
      return this.tempValue && this.clearable;
    }
  },
  methods: {
    querySearchAsync: _.debounce(function(name, cb) {
      if (!name) {
        cb([]);
        this.selectSchool(null);
        return false;
      }
      this.$http._get({
        url: '/finance/gkry/searchSchool',
        data: {
          name,
        }
      }).then(({ data }) => {
        const schoolData = Array.isArray(data) ? data : Object.values(data);
        let schools = [];
        schoolData.forEach((item) => {
          item.value = item.name;
          schools.push(item);
        });
        cb(schools);
      });
    }, 300),
    selectSchool(val) {
      if (val) {
        this.tempValue = val.name;
        this.$emit('change', val.id);
      }
    },
    clearInput() {
      this.tempValue = '';
      this.selectSchool(null);
    },
    focus() {
      this.$refs.complete.focus();
    }
  },
  watch: {
    value: {
      handler: function (val) {
        if (!val) {
          this.tempValue = '';
        }
      }
    }
  },
  mounted() {
    if (this.value) {
      this.tempValue = this.value.name;
    }
  }
};
</script>
